/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UnpublishedChangesWarningModalDispatchParams {
    documentName: string;
    lastOpenedDays: number;
    documentId: number;
}

interface UnpublishedChangesWarningModalState {
    isOpen: boolean;
    data: UnpublishedChangesWarningModalDispatchParams | null;
}

const initialState: UnpublishedChangesWarningModalState = {
    isOpen: false,
    data: null,
};

export const unpublishedChangesWarningModalSlice = createSlice({
    name: 'unpublished-changes-warning-modal',
    initialState,
    reducers: {
        open(state: UnpublishedChangesWarningModalState, action: PayloadAction<UnpublishedChangesWarningModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: UnpublishedChangesWarningModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});

export const { open, close } = unpublishedChangesWarningModalSlice.actions;

export default unpublishedChangesWarningModalSlice.reducer;

export type {
    UnpublishedChangesWarningModalState,
    UnpublishedChangesWarningModalDispatchParams,
}; 